// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__26aoh","options":"AnswerScale_options__2m4E8","selected":"AnswerScale_selected__2zlkm"};